export default __webpack_public_path__ + "static/13-75455b6429e5d3c95ae8805c1cf01aac.webp";